import { toast } from 'react-toastify';

const notification = (type = 'info', message) => {
    switch (type) {
        case 'success': {
            toast.success(`✅ ${message}`, {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: 0
            });
            break;
        }
        case 'error': {
            toast.error(`❌ ${message}`, {
                position: 'top-right',
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: 0
            });
            break;
        }
        case 'info': {
            toast.info(`⚠️ ${message}`, {
                position: 'top-right',
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: 0
            });
            break;
        }
        default: {
            toast.info(message, {
                position: 'top-right',
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: 0
            });
        }
    }
};

export { notification };
